import OrderAppLib from 'dimorder-orderapp-lib'

function createOrderLocaleHelper(symbolName) {
  return OrderAppLib.libs.createLocaleHelper({
    getCountryFromStore() {
      return symbolName
    },
  })
}

export function currencyWithCommas(num, symbolName, minimumFractionDigits) {
  if (num === undefined || !num) {
    num = 0
  }

  return createOrderLocaleHelper(symbolName).formatCurrency(num, {
    minimumFractionDigits,
  })
}

export function numberWithCommas(num) {
  return Number(num).toLocaleString()
}

export function getCurrencySymbol(symbolName) {
  return createOrderLocaleHelper(symbolName).getCurrencySymbol() ?? '$'
}

export default {
  numberWithCommas,
  currencyWithCommas,
  getCurrencySymbol,
}
